import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const CategoryList = Loadable(lazy(() => import('./LeadList')));

const LeadRoutes = [
	{
		path: '/dashboard/leadlist',
		element: <CategoryList />,
		auth: authRoles.admin,
	},
];

export default LeadRoutes;
